module.exports = require("live/services/global-notification");